import { SET_REVIEWS } from '../actions/types';

export default function reviews(state = [], action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_REVIEWS:
				return action.payload;

			// no default
		}
	}

	return state;
}
